import React from 'react';
import {compose, withProps} from 'recompose'
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker
} from 'react-google-maps';
import PropTypes from 'prop-types';
import {FormattedMessage, intlShape} from 'react-intl';
import Location from "./Location";
import {LocationShape} from "../../common/react/Shapes";
import MessageDefinitions from "../i18n/MessageDefinitions";
import FontAwesome from 'react-fontawesome';

class LocationsMap extends React.Component {
  static propTypes = {
    onClick: PropTypes.func,
    selectedLocation: LocationShape,
    zipCode: PropTypes.string,
    onGeoLocationChange: PropTypes.func,
    onGeoLocationFailure: PropTypes.func,
    locations: PropTypes.arrayOf(LocationShape),
    isLoading: PropTypes.bool
  };

  static contextTypes = {
    intl: intlShape
  };

  constructor(props) {
    super(props);
    this.state = {
      init: false,
      center: {
        lat: 32.948809, lng: -96.805041 //Ignite Sales Office
      },
    };
  }

  setCenterAndZoom = () => {
    if (this.props.locations.length > 0) {
      const bounds = new window.google.maps.LatLngBounds();
      this.props.locations.forEach(location => bounds.extend(new window.google.maps.LatLng(location.lat, location.lng)));
      this.refs.map.fitBounds(bounds);
    }
  };

  queryForLocations = () => {
    if(this.props.zipCode && this.props.zipCode.length === 5) {
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({'address': this.props.zipCode}, (response, status) => {
          if (status.toLowerCase() === 'ok') {
            const lat = response[0].geometry.location.lat();
            const lng = response[0].geometry.location.lng();
            this.props.onGeoLocationChange({lat, lng});
          } else {
            console.log("Unable to obtain location geography data for zip code: "+ this.props.zipCode);
            this.props.onGeoLocationFailure();
          }
      });
    }
  };

  componentDidUpdate(prevProps, prevState){
    if(this.props.zipCode !== prevProps.zipCode) {
      this.queryForLocations();
    }
    this.setCenterAndZoom();
  }

  componentDidMount() {
    this.queryForLocations();
    this.setCenterAndZoom();
  }

  render() {
    const { onClick, selectedLocation, locations, isLoading } = this.props;
    const { center } = this.state;

    const mapLocationListings = locations.map(item => {
      const isSelected = selectedLocation && selectedLocation.id === item.id;
      const listingClicked = () => {
        onClick(item);
      };

      return <Location key={item.id} location={item} onClick={listingClicked} selected={isSelected} />;
    });

    const mapMarkers = locations.map(item => {
      const markerClicked = () => {
        onClick(item);
      };
      const opacity = selectedLocation && selectedLocation.id === item.id ? 1 : 0.55;

      return <Marker key={item.id} position={{ lat: item.lat, lng: item.lng }} onClick={markerClicked} opacity={opacity} />;
    });

    return (
      <div className="locationsAndMapSection">
        {isLoading ? <div className="loading-section"><FontAwesome name="spinner" spin/></div> : null }
        <div className='locations'>
          { mapLocationListings.length ? mapLocationListings : <FormattedMessage {...MessageDefinitions.appointmentNoLocations} /> }
        </div>
        <GoogleMap
          ref='map'
          defaultZoom={10}
          defaultCenter={center}
        >
          {mapMarkers}
        </GoogleMap>
      </div>
    );
  }
}

const MapComponent = compose(
  withProps({
    googleMapURL: "https://maps.googleapis.com/maps/api/js?key=AIzaSyA-tE9qr3vCaZsrv1KveSqhVOT_d9zZ39A&v=3.exp&libraries=geometry,drawing,places",
    loadingElement: <div className='mapLoading' style={{ height: `100%` }} />,
    containerElement: <div className='mapContainer' style={{ height: `400px` }} />,
    mapElement: <div className='mapElement' style={{ height: `100%` }} />,
  }),
  withScriptjs,
  withGoogleMap
)(LocationsMap);

export default MapComponent;



/** WEBPACK FOOTER **
 ** ./src/main/js/contactMe/components/LocationsMap.js
 **/